import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  projectKeys,
  projectMutationKeys,
} from '@core/react-query/features/projects/project'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { projectsKeys } from '@core/react-query/features/projects'
import { PageResponse } from '@core/entities/pagination'

export const useUpdateProject = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['updateProject']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectMutationKeys.updateProject,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(
        projectKeys.byId({ projectId: variables.projectId }).queryKey,
        {},
      )
      queryClient.setQueriesData<PageResponse<any>>(
        { queryKey: projectsKeys.getAllProjects._def, exact: false },
        (projectsList) => {
          if (!projectsList) return
          const content = projectsList.content.map((project) => {
            if (project.id === variables.projectId) {
              return { ...project, ...data }
            } else {
              return project
            }
          })
          return { ...projectsList, content }
        },
      )
    },
  })
}
